import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, FilterDropdown, StatusComponent } from "../../../common/component/Index";
import TicketSold from './../../../../../models/TicketSold';
import { withTranslation } from "react-i18next";
import { Icon, Menu, Tooltip } from 'antd';
import { DATE_TIME_FORMAT, ORDER, PATHS, TRANSLATE_LANGUAGE, VOUCHER } from '../../../../../constants/Define';
import moment from "moment";
import Dropdown from '../../../common/component/Dropdown';
import Modal from '../../../common/component/Modal';
import { FlagIcons } from '../../../common/component/TranslateButton';
import { find, toArray } from 'lodash'
import EllipsisText from '../../../common/component/EllipsisText';
import FontIcon, { SolidIcons } from '../../../common/component/FontIcon';
import Span from '../../../common/component/Span';
import "./TicketSoldList.less";

const ListCols = ['serialNumber', 'verifyCode', 'skuCode', 'tourName', 'ticketCode', 'objectType', 'productType',
'rateCode', 'saleDate', 'propertyName', 'stayStartDate', 'stayEndDate', 'operaBooking', 'status'];
const ModelFields = Object.getOwnPropertyNames(new TicketSold());

class TicketSoldList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, [], []),
            modelItem: ModelFields,
            componentTable: {
                serialNumber: {
                    key: 'serialNumber',
                    fixed: 'left',
                    // sorter: (i, k) => i.serialNumber.length - k.length,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                            handleSearch={this.handleSearch}
                            handleReset={this.handleReset}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => text
                },
                verifyCode: {
                    key: 'verifyCode',
                    fixed: 'left',
                },
                skuCode: {
                    key: 'skuCode',
                    // sorter: (i, k) => i.skuCode.length - k.length,
                    render: (skuCode, record)=> <EllipsisText title={skuCode} content={skuCode} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={Tooltip} />,
                    defaultFilteredValue: [this.props.defaultTourCodeFilter],
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                            handleSearch={this.handleSearch}
                            handleReset={this.handleReset}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                },
                tourName: {
                    key: 'tourName',
                    width: 200,
                    render: (tourName, record)=> <EllipsisText title={tourName} content={tourName} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={Tooltip} />,
                },
                tourName: {
                    key: 'tourName',
                    width: 200
                },
                ticketCode: {
                    key: 'ticketCode',
                    // sorter: (i, k) => i.ticketCode.length - k.length,
                    defaultFilteredValue: [this.props.defaultCodeFilter],
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            // defaultValue={this.props.defaultCodeFilter}
                            confirm={confirm}
                            clearFilters={clearFilters}
                            handleSearch={this.handleSearch}
                            handleReset={this.handleReset}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => text
                },
                productType: {
                    key: 'productType',
                    render: (productType, data) => <Fragment>
                        {<div className="g-mt-5">
                            <StatusComponent color={productType === 1 ? 'blue' : 'green'}
                                label={this.props.t(`item.tour.types.${productType === 1 ? 'voucher' : 'tour' }`)} />
                        </div>
                        }
                    </Fragment>,
                    filters: [
                        { value: 1, text: this.props.t(`item.tour.types.voucher`) },
                        { value: 2, text: this.props.t(`item.tour.types.tour`) },
                    ],
                    filterMultiple: true,
                },
                propertyName: {
                    key: 'propertyName',
                    width: 200,
                    render: (propertyName, record) => {
                        return record.properties.map(property => <p>{property.name}</p>)
                    }
                },
                objectType: {
                    key: 'objectType',
                    width: 200,
                    render: (objectType, record) => <EllipsisText title={objectType} content={objectType} contentMaxWidth={280}
                    overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                },
                rateCode: {
                    key: 'rateCode',
                    render: (rateCode, record)=>{
                        return <div className="ratecode-open-new" onClick={()=> this.onOpenRateCode(record)}>
                                {record.rateCode}
                            </div>
                    }
                },
                stayStartDate: {
                    key: 'stayStartDate',
                    render: (date, record) => date && record.productType === 2 && moment(moment.utc(date).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                stayEndDate: {
                    key: 'stayEndDate',
                    render: (date, record) => date && record.productType === 2 && moment(moment.utc(date).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                saleDate: {
                    key: 'saleDate',
                    render: (date, record) => date && moment(moment.utc(date).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                status: {
                    key: 'status',
                    render: (status, record) => {
                        const statusEnum = find(toArray(VOUCHER.STATUS), item => item.id === status)
                        return !!statusEnum && <Fragment>
                            <StatusComponent color={statusEnum.color}
                                label={this.props.t(`item.voucher.statusVoucher.${statusEnum.key}`)} />
                            {record.isLocked && <Icon type="lock" style={{ color: VOUCHER.STATUS.LOCKED.color }} />}
                        </Fragment>
                    },
                    filters: toArray(VOUCHER.STATUS).map((item) => ({
                        value: item.id,
                        text: this.props.t(`item.voucher.statusVoucher.${item.key}`),
                    })),
                    filterMultiple: false,
                },
                action: {
                    width: 100,
                    align: 'right',
                    fixed: 'right',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            filters: {},
        };
    }

    render() {
        const { loading, pagination, ticketSolds } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return (
            <ListComponent
                tableKey="ticketSolds-list"
                classChildren="p-0" classParent="m-0"
                scroll={{ x: 2000 }}
                rowKey={(record, k) => record.serialNumber ? record.serialNumber : k}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(ticketSolds || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'ticketSold'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize }}
                componentTableList={{}}
                onColumnVisibleChange={this.onColumnVisibleChange}
            />
        );
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const removeTicketSold = () => {
            return this.props.onDelete && this.props.onDelete(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.TicketSold.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeTicketSold,
            });
        };
        return (
            <Fragment>
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {
                            permisions && permisions.allowUpdate &&
                            <Menu.Item>
                                <Link to={Func.getPathWithParams(PATHS.OBJECT_TYPES.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                    <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                                </Link>
                            </Menu.Item>
                        }
                        {
                            permisions && permisions.allowDelete &&
                            <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }

    componentDidMount(){
        // getColumnVisibleConfigs(ListKeyString, this.state.componentTable);
    }

    onColumnVisibleChange = (column, isVisibled) => {
        const { componentTable } = this.state;
        componentTable[column.dataIndex].visible = isVisibled;
        // setColumnVisibleConfigs(ListKeyString, componentTable);
        this.setState({ componentTable })
    }

    onOpenRateCode = (data)=>{
        window.open(`${PATHS.RATECODE.CREATE.path}/${data.rateCodeId}`);
    }

}

export default withTranslation()(TicketSoldList);
